((): void => {
  if (!import.meta.env.PUBLIC_AUTH0_DOMAIN) {
    throw new Error('Environment variable [PUBLIC_AUTH0_DOMAIN] is not set.');
  }
  if (!import.meta.env.PUBLIC_AUTH0_CLIENT_ID) {
    throw new Error(
      'Environment variable [PUBLIC_AUTH0_CLIENT_ID] is not set.'
    );
  }
  if (!import.meta.env.PUBLIC_AUTH0_AUDIENCE) {
    throw new Error('Environment variable [PUBLIC_AUTH0_AUDIENCE] is not set.');
  }
})();

const AUTH0_DOMAIN = import.meta.env.PUBLIC_AUTH0_DOMAIN;

const AUTH0_CLIENT_ID = import.meta.env.PUBLIC_AUTH0_CLIENT_ID;

const AUTH0_AUDIENCE = import.meta.env.PUBLIC_AUTH0_AUDIENCE;

const AUTH0_SCOPE = 'profile email';

const AUTH0_DISABLED =
  ['true', 'TRUE', '1'].includes(import.meta.env.PUBLIC_AUTH0_DISABLED || '') &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const AUTH0_ORGANIZATION_KEY = 'https://city-sim-app.exapmle.com/organization';
const AUTH0_ROLES_KEY = 'https://city-sim-app.exapmle.com/roles';

const AUTH0_ADMIN_ROLE_NAME = 'OrganizationAdmin';

export {
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE,
  AUTH0_SCOPE,
  AUTH0_DISABLED,
  AUTH0_ORGANIZATION_KEY,
  AUTH0_ROLES_KEY,
  AUTH0_ADMIN_ROLE_NAME,
};
